import { userService } from '../services';
import router from '../router';

const userType = process.env.ROLE;

const state = {
  account: {
    loggedIn: false,
    user: null,
    token: null,
  },
  toUrl: null,
  fromUrl: null,
  acceptTerms: false,
};

const user = JSON.parse(localStorage.getItem('user'));
state.acceptTerms = JSON.parse(localStorage.getItem('acceptTerms')) || false;

if (user && user.role === userType) {
  state.account = {
    loggedIn: true,
    user,
    token: null,
  };
}

const getters = {
  // fullname(state) {
  //   return `${state.account.user.firstname} ${state.account.user.lastname}`;
  // },
  // getCurrentUser(state) {
  //   return state.account.user.id;
  // },
  profileId: state => state.account.user.customer_id,
  isVerified: state => state.account.user.is_verified,
};

const actions = {
  async login({ dispatch, commit }, { email, password, role }) {
    dispatch('alert/busy', null, { root: true });
    try {
      // Log user in
      const user = await userService.login(email, password, role);
      // Get user profile
      commit('loginSuccess', user);
      await dispatch('alert/success', 'Login success', { root: true });
      if (state.toUrl) {
        const url = state.toUrl;
        commit('clearToUrl');
        router.push(url);
      } else {
        router.push('/');
      }
    } catch (error) {
      await dispatch('alert/error', error, { root: true });
    }
  },
  async logout({ dispatch, commit }) {
    try {
      commit('cart/emptyCart', null, { root: true });
      commit('logout');
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
  async register({ dispatch }, data) {
    dispatch('alert/busy', null, { root: true });
    try {
      await userService.register(data);
      dispatch('alert/success', 'Registration success', { root: true });
      router.push('/register-ok');
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
  async updateAccount({ dispatch, commit }, { form, id }) {
    dispatch('alert/busy', null, { root: true });
    try {
      await userService.updateAccount(form, id);
      dispatch('alert/success', 'Account updated', { root: true });
      commit('editSuccess', form);
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
  async resetPassword({ dispatch }, form) {
    dispatch('alert/busy', null, { root: true });
    try {
      await userService.resetPassword(form);
      dispatch('alert/success', 'Password reset', { root: true });
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
  async deleteAccount({ dispatch, commit }) {
    dispatch('alert/busy', null, { root: true });
    try {
      await userService.deleteAccount();
      dispatch('alert/success', 'Account removed', { root: true });
      commit('logout');
    } catch (error) {
      dispatch('alert/error', error, { root: true });
    }
  },
};

const mutations = {
  loginSuccess(state, user) {
    state.account.loggedIn = true;
    localStorage.setItem('user', JSON.stringify(user));
    state.account.user = user;
  },
  logout(state) {
    state.account.user = null;
    state.account.loggedIn = false;
    localStorage.removeItem('user');
    router.push('/');
  },
  editSuccess(state, user) {
    state.account.user = {
      ...state.account.user,
      ...user,
    };
    // localStorage.setItem('user', JSON.stringify(user));
  },
  setToUrl(state, url) {
    state.toUrl = url;
  },
  setFromUrl(state, url) {
    state.fromUrl = url;
  },
  clearToUrl(state) {
    state.toUrl = null;
  },
  setAccountVerified(state) {
    state.account.user.is_verified = true;
    localStorage.setItem('user', JSON.stringify(state.account.user));
  },
  acceptTermsNow(state) {
    state.acceptTerms = true;
    localStorage.setItem('acceptTerms', true);
  },
};

export const account = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/account.module.js